import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['verdictsNotTurnedOn', 'canEnableMessage', 'cannotEnableMessage', 'turnOnLink']

  declare readonly verdictsNotTurnedOnTarget: HTMLElement
  declare readonly canEnableMessageTarget: HTMLElement
  declare readonly cannotEnableMessageTarget: HTMLElement
  declare readonly turnOnLinkTarget: HTMLAnchorElement

  get dialog(): HTMLDialogElement {
    return this.element as HTMLDialogElement
  }

  open({ name, canEnable, editUrl }: { name: string; canEnable: boolean; editUrl?: string }) {
    this.verdictsNotTurnedOnTarget.textContent =
      `Survey Scoring & Verdicts has not been turned on for ${name}.`

    this.canEnableMessageTarget.classList.toggle('hide', !canEnable)
    this.cannotEnableMessageTarget.classList.toggle('hide', canEnable)

    if (canEnable && editUrl) {
      this.turnOnLinkTarget.href = editUrl
      this.turnOnLinkTarget.classList.remove('hide')
    } else {
      this.turnOnLinkTarget.classList.add('hide')
    }

    this.dialog.showModal()
  }

  close() {
    this.dialog.close()
  }

  closeOnBackdrop(event: Event) {
    if (event.target === this.element) this.dialog.close()
  }

  openFromLink(event: Event) {
    event.preventDefault()
    this.dialog.close()
    loadMainBody(this.turnOnLinkTarget)
  }
}
